module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-searchHead', {
    attrs: {
      "type": _vm.headType.searchHead,
      "keywords": _vm.$route.query.keyword
    }
  }), _vm._v(" "), (_vm.isReload && !_vm.findLikeWord) ? _c('div', {
    staticClass: "search-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hotword-body"
  }, _vm._l((_vm.hotwords), function(hot) {
    return _c('button', {
      on: {
        "click": function($event) {
          _vm.search(hot)
        }
      }
    }, [_vm._v(_vm._s(hot))])
  })), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "history-body"
  }, _vm._l((_vm.histories), function(h) {
    return _c('button', {
      on: {
        "click": function($event) {
          _vm.search(h)
        }
      }
    }, [_vm._v(_vm._s(h))])
  })), _vm._v(" "), _c('div', {
    staticClass: "clear-history",
    on: {
      "click": function($event) {
        _vm.clearHistory()
      }
    }
  }, [_c('span', [_vm._v("清空搜索历史")])]), _vm._v(" "), _c('div', {
    staticClass: "find-quan"
  }, [_c('img', {
    attrs: {
      "src": require('../../static/img/H5-find-quan.png')
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isReload && _vm.findLikeWord) ? _c('div', {
    staticClass: "like-word"
  }, _vm._l((_vm.likeWords), function(k) {
    return _c('div', {
      staticClass: "like-word-item",
      domProps: {
        "innerHTML": _vm._s(_vm.showK(k))
      },
      on: {
        "click": function($event) {
          _vm.search(k)
        }
      }
    }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.showK(k)) + "\n      ")])])
  })) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotword-title"
  }, [_c('span', [_vm._v("热门搜索")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history-title"
  }, [_c('span', [_vm._v("搜索历史")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0934dc3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 195
// module chunks = 2